import { isUndNullEmp } from '../../helpers/main.js';

export class ParameterDetail {
    constructor(
        _id = 0,
        _parameterId = 0,
        _deviceId = 0,
        _mark = '',
        _serial = '',
        _model = '',
        _description = '',
        _primaryIp = '',
        _primaryMacAddress = '',
        _primaryDNS = '',
        _secondaryIp = '',
        _secondaryMacAddress = '',
        _secondaryDNS = '',
        _adminUser = '',
        _adminPassword = '',
        _domainUser = '',
        _teamViewverId = '',
        _teamViewverPassword = '',
        _observations = '',
        _register = '',
    ) {
        this.id = _id;
        this.parameterId = _parameterId;
        this.deviceId = _deviceId;
        this.mark = _mark;
        this.serial = _serial;
        this.model = _model;
        this.description = _description;
        this.primaryIp = _primaryIp;
        this.primaryMacAddress = _primaryMacAddress;
        this.primaryDNS = _primaryDNS;
        this.secondaryIp = _secondaryIp;
        this.secondaryMacAddress = _secondaryMacAddress;
        this.secondaryDNS = _secondaryDNS;
        this.adminUser = _adminUser;
        this.adminPassword = _adminPassword;
        this.domainUser = _domainUser;
        this.teamViewverId = _teamViewverId;
        this.teamViewverPassword = _teamViewverPassword;
        this.observations = _observations;
        this.register = _register;
    }

    static getClassParameterId = () => {
        return 'ParameterDetail - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    ParameterId: 0,
                    DeviceId: 0,
                    Mark: 1,
                    Serial: 1,
                    Model: 1,
                    Description: 1,
                    PrimaryIp: 1,
                    PrimaryMacAddress: 1,
                    PrimaryDNS: 1,
                    SecondaryIp: 1,
                    SecondaryMacAddress: 1,
                    SecondaryDNS: 1,
                    AdminUser: 1,
                    AdminPassword: 1,
                    DomainUser: 1,
                    TeamViewverId: 1,
                    TeamViewverPassword: 1,
                    Observations: 1,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    ParameterId: 450,
                    DeviceId: 450,
                    Mark: 50,
                    Serial: 50,
                    Model: 50,
                    Description: 50,
                    PrimaryIp: 100,
                    PrimaryMacAddress: 100,
                    PrimaryDNS: 100,
                    SecondaryIp: 100,
                    SecondaryMacAddress: 100,
                    SecondaryDNS: 100,
                    AdminUser: 50,
                    AdminPassword: 50,
                    DomainUser: 50,
                    TeamViewverId: 20,
                    TeamViewverPassword: 20,
                    Observations: 1000,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    parameterId: 0,
                    deviceId: 0,
                    mark: 1,
                    serial: 1,
                    model: 1,
                    description: 1,
                    primaryIp: 1,
                    primaryMacAddress: 1,
                    primaryDNS: 1,
                    secondaryIp: 1,
                    secondaryMacAddress: 1,
                    secondaryDNS: 1,
                    adminUser: 1,
                    adminPassword: 1,
                    domainUser: 1,
                    teamViewverId: 1,
                    teamViewverPassword: 1,
                    observations: 1,
                    register: 10,
                },
                max: {
                    id: 450,
                    parameterId: 450,
                    deviceId: 450,
                    mark: 50,
                    serial: 50,
                    model: 50,
                    description: 50,
                    primaryIp: 100,
                    primaryMacAddress: 100,
                    primaryDNS: 100,
                    secondaryIp: 100,
                    secondaryMacAddress: 100,
                    secondaryDNS: 100,
                    adminUser: 50,
                    adminPassword: 50,
                    domainUser: 50,
                    teamViewverId: 20,
                    teamViewverPassword: 20,
                    observations: 1000,
                    register: 30,
                },
            };
        }
    }

    // static userIdFullPath = ({userId = '', subMethod = ''} = {}) => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'ParameterDetail / userIdFullPath';
    //     try {
    //         if(!isUndNullEmp({data: userId, subMethod: currentMethod})?.result){
    //             userId = userId.replace('~/Images/UserIds/ParameterDetail/', `${settings.backend.urls.imageUserIds}${settings.backend.urls.paymentInformations}/`);
    //             response.result = `${settings.backend.urls.api}${userId}`
    //         } else {
    //             response.result = `${settings.backend.urls.api}${settings?.images?.noImage}`;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //     }
    //     return response;
    // }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: ParameterDetail.getClassParameterId() })?.result) {
            if (upperCase) {
                return new ParameterDetail(
                    obj.Id,
                    obj.ParameterId,
                    obj.DeviceId,
                    obj.Mark,
                    obj.Serial,
                    obj.Model,
                    obj.Description,
                    obj.PrimaryIp,
                    obj.PrimaryMacAddress,
                    obj.PrimaryDNS,
                    obj.SecondaryIp,
                    obj.SecondaryMacAddress,
                    obj.SecondaryDNS,
                    obj.AdminUser,
                    obj.AdminPassword,
                    obj.DomainUser,
                    obj.TeamViewverId,
                    obj.TeamViewverPassword,
                    obj.Observations,
                    obj.Register,
                );
            } else {
                return new ParameterDetail(
                    obj.id,
                    obj.parameterId,
                    obj.deviceId,
                    obj.mark,
                    obj.serial,
                    obj.model,
                    obj.description,
                    obj.primaryIp,
                    obj.primaryMacAddress,
                    obj.primaryDNS,
                    obj.secondaryIp,
                    obj.secondaryMacAddress,
                    obj.secondaryDNS,
                    obj.adminUser,
                    obj.adminPassword,
                    obj.domainUser,
                    obj.teamViewverId,
                    obj.teamViewverPassword,
                    obj.observations,
                    obj.register,
                );
            }
        } else {
            return new ParameterDetail();
        }
    }
}